import {Component, OnInit} from '@angular/core';
import { Router} from '@angular/router';

import { CDSTreeService } from '../services/cds.service';
import {CAPDAdminComponent} from "../capd-admin-component/capd-admin.component";

@Component({
  selector: 'mmodal-manager',
  templateUrl: './mmodal-manager.component.html'
})

export class MModalManagerComponent implements OnInit {
    protected readonly sessionStorage = sessionStorage;
 uiVersion: string = sessionStorage.getItem('uiVersion');

  constructor(
    private _service: CDSTreeService,
    private _router: Router,
    private _adminComponent: CAPDAdminComponent
  ) {
    this._adminComponent.uiChangeEvent.subscribe({
      next: (event) => {
        this.uiVersion = event
      }
    })
  }

  ngOnInit() {
    this._service.getRootId().then(() => {
      if (sessionStorage.getItem('rootId') != null && sessionStorage.getItem('rootId') !== '~' && this.uiVersion === 'Classic') {
        this._router.navigate(['main/company/' + sessionStorage.getItem('rootId')]);
      } else if (sessionStorage.getItem('rootId') != null && sessionStorage.getItem('rootId') === '~' && this.uiVersion === 'Version 2') {
          this._router.navigate(['main/mmodal/v2/library']);
      }
    });
  }
}
